// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import { API_STATUS } from 'store/constants';
// import { updateUserToSessionStorage } from 'utils/userUtil';
// import { attemptCreateUser, attemptUpdateUser, fetchUserInfo } from './userAPI';

// const session = sessionStorage.getItem('user');
// let initialState = {
// 	isLoggedIn: true,
// 	isInitialized: true,
// 	info: {
// 		notifications: { email: true, text: false, whatsapp: false },
// 		isAdmin: false
// 	}
// };
// if (session) {
// 	initialState = JSON.parse(session);
// }

// export const getUserInfoAsync = createAsyncThunk('user/fetchUserInfo', async userId => {
// 	const user = await fetchUserInfo(userId);
// 	return user && { user, isLoggedIn: true };
// });

// export const createUserAsync = createAsyncThunk('user/attemptCreateUser', async newUser => {
// 	await attemptCreateUser(newUser);
// 	return { user: newUser, isLoggedIn: true };
// });

// export const updateUserAsync = createAsyncThunk('user/attemptUpdateUser', async updatedUser => {
// 	const { userId, ...data } = updatedUser;
// 	await attemptUpdateUser(userId, data);
// 	return { updatedUser };
// });

// export const userSlice = createSlice({
// 	name: 'user',
// 	initialState,
// 	reducers: {
// 		setUser: (state, action) => {
// 			state.info = action.payload.user;
// 			state.isLoggedIn = action.payload.isLoggedIn;
// 			state.isInitialized = true;
// 			updateUserToSessionStorage(state);
// 		},
// 		setLoggedIn: (state, action) => {
// 			state.isLoggedIn = action.payload;
// 		},
// 		onLogout: (state, action) => {
// 			state = initialState;
// 		},
// 		updateUser: (state, action) => {
// 			const { notifications, ...rest } = action.payload;
// 			state = {
// 				...state,
// 				notifications: { ...state.notifications, ...notifications },
// 				...rest
// 			};
// 			updateUserToSessionStorage(state);
// 		},
// 		setDemographicsComplete: (state, action) => {
// 			state.demographicsDate = action.payload;
// 		},
// 		setLastAssessmentDate: (state, action) => {
// 			state.lastAssessmentDate = action.payload;
// 		}
// 	},

// 	extraReducers: builder => {
// 		builder
// 			.addCase(createUserAsync.fulfilled, (state, action) => {
// 				state.info = action.payload.user;
// 				state.isLoggedIn = action.payload.isLoggedIn;
// 				state.isInitialized = true;
// 				updateUserToSessionStorage(state);
// 			})
// 			.addCase(createUserAsync.rejected, state => {
// 				state.status = API_STATUS.REJECTED;
// 			})
// 			.addCase(updateUserAsync.fulfilled, (state, action) => {
// 				state.info = { ...state.info, ...action.payload.updatedUser };
// 				updateUserToSessionStorage(state);
// 			})
// 			.addCase(updateUserAsync.rejected, state => {
// 				state.status = API_STATUS.REJECTED;
// 			});
// 	}
// });

// export const selectUser = state => state.user;
// export const isLoggedIn = state => state.user.loggedIn;
// export const selectIsAdmin = state => state.user.info?.isAdmin;
// export const isDemographicsComplete = state => state.user?.loggedIn && !!state.user?.demographicsDate;

// export const selectUserNotifications = state => state.user.info?.notifications || {};
// export const selectUserPreferences = state => state.user.info?.preferences || { parents: [], couples: [] };

// export const { setUser, setLoggedIn, onLogout, updateUser, setDemographicsComplete, setLastAssessmentDate } =
// 	userSlice.actions;

// export default userSlice.reducer;

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_STATUS } from 'store/constants';
import { updateUserToSessionStorage } from 'utils/userUtil';
import { attemptCreateUser, attemptUpdateUser, fetchUserInfo } from './userAPI';

// --- THIS IS THE FIRST PART OF THE FIX ---
// We define a truly initial state. The app has not checked anything yet.
const defaultInitialState = {
    isLoggedIn: false,
    isInitialized: false,
    info: null,
};

// We then try to load the state from session storage, but fall back to the safe default.
let initialState = defaultInitialState;
try {
    const session = sessionStorage.getItem('user');
    if (session) {
        initialState = JSON.parse(session);
        // Crucially, we still force re-initialization on every page load.
        initialState.isInitialized = false;
    }
} catch (e) {
    // If session storage is corrupt, we start fresh.
    initialState = defaultInitialState;
}
// --- END OF FIX ---


export const getUserInfoAsync = createAsyncThunk('user/fetchUserInfo', async userId => {
    const user = await fetchUserInfo(userId);
    // The thunk now only returns the user data. The reducer will handle the flags.
    return user;
});

export const createUserAsync = createAsyncThunk('user/attemptCreateUser', async newUser => {
    await attemptCreateUser(newUser);
    return newUser;
});

export const updateUserAsync = createAsyncThunk('user/attemptUpdateUser', async updatedUser => {
    const { userId, ...data } = updatedUser;
    await attemptUpdateUser(userId, data);
    return { updatedUser };
});

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        // This is now the single source of truth for updating the user state.
        setUser: (state, action) => {
            state.info = action.payload.user;
            state.isLoggedIn = action.payload.isLoggedIn;
            state.isInitialized = true; // This is the ONLY place this becomes true.
            updateUserToSessionStorage(state);
        },
        // The other reducers remain for specific, synchronous actions.
        setLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        onLogout: (state, action) => {
            state.isLoggedIn = false;
            state.info = null;
            updateUserToSessionStorage(state);
        },
        updateUser: (state, action) => {
            const { notifications, ...rest } = action.payload;
            state.info = { ...state.info, ...rest };
            state.info.notifications = { ...state.info.notifications, ...notifications };
            updateUserToSessionStorage(state);
        },
        setDemographicsComplete: (state, action) => {
            state.demographicsDate = action.payload;
        },
        setLastAssessmentDate: (state, action) => {
            state.lastAssessmentDate = action.payload;
        }
    },

    extraReducers: builder => {
        builder
            .addCase(getUserInfoAsync.fulfilled, (state, action) => {
                // This case is now handled by the robust `useEffect` in FirebaseContext.
                // We keep it here to avoid breaking other parts of the app that might use it.
            })
            .addCase(createUserAsync.fulfilled, (state, action) => {
                state.info = action.payload;
                state.isLoggedIn = true;
                state.isInitialized = true;
                updateUserToSessionStorage(state);
            })
            .addCase(updateUserAsync.fulfilled, (state, action) => {
                state.info = { ...state.info, ...action.payload.updatedUser };
                updateUserToSessionStorage(state);
            });
    }
});

export const selectUser = state => state.user;
export const isLoggedIn = state => state.user.isLoggedIn;
export const selectIsAdmin = state => state.user.info?.isAdmin === true;
export const isDemographicsComplete = state => state.user?.isLoggedIn && !!state.user?.demographicsDate;

export const selectUserNotifications = state => state.user.info?.notifications || {};
export const selectUserPreferences = state => state.user.info?.preferences || { parents: [], couples: [] };

export const { setUser, setLoggedIn, onLogout, updateUser, setDemographicsComplete, setLastAssessmentDate } =
    userSlice.actions;

export default userSlice.reducer;